import BaseApi from '@/api/rest/base/BaseApi';

export default class extends BaseApi {
  static entityName = 'company_department_members';
}
